/* tslint:disable */
/* eslint-disable */
export enum WorkMontageplanBlockOrientationTypeEnum {
  ProjectOriented = 'PROJECT_ORIENTED',
  TaskOriented = 'TASK_ORIENTED'
}
